export default __webpack_public_path__ + "static/media/gilroy-bold-4-webfont.fc596ebe.woff2";